import {
	FETCH_HOTEL_DESC_INFO_BEGIN,
	FETCH_HOTEL_DESC_INFO_SUCCESS,
	FETCH_HOTEL_DESC_INFO_FAILURE,
} from '../actions/fetchHotelDescriptiveInfo'

import merge from 'lodash/merge'

const initialState = {
	hotelInfo: [],
	loading: false,
	error: null,
}

export default function fetchHotelDescriptiveInfoReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_HOTEL_DESC_INFO_BEGIN:
			// Request begin: set loading true
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_HOTEL_DESC_INFO_SUCCESS:
			// Request success: set loading false, set hotelInfo data
			return {
				...state,
				loading: false,
				error: null,
				hotelInfo: merge({}, state.hotelInfo, action.payload)
			}

		case FETCH_HOTEL_DESC_INFO_FAILURE:
			// Request failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				hotelInfo: [],
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchHotelDescriptiveInfoReducers.js